export default "__VITE_ASSET__81e029a4__"